import {ErrorHandler, Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {CommonFunctionsService} from "./common-functions.service";

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {

    constructor(private commonFunctions: CommonFunctionsService) {
    }

    handleError(error: any, res: any = null) {
        if (this.commonFunctions.showHttpError(error, res)) {
            if (error) console.log(error);
            if (res) console.log(res);
            console.trace();
        }
    }
}
